import React from 'react';
import { observer } from 'mobx-react';
import { config } from '../../config';

// Translations
import translate from '../Translate.js';

const ProctoringInfo = observer(class RegisterStep02 extends React.Component {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const { SessionStore, SettingsStore } = this.props.store;

    this.state = {
      proctorTypes: [],
      invalid: false
    }

    SessionStore.getProctorTypes();
    SettingsStore.getUserSettings(this);
  }

  handleToggle(e) {
    const proctorTypes = [...this.state.proctorTypes];

    if(e.target.checked) {
      proctorTypes.push(e.target.value);
    } else {
      const index = proctorTypes.indexOf(e.target.value);
      proctorTypes.splice(index, 1);
    }

    this.setState({
      proctorTypes
    });
  }

  handleSubmit() {
    const checked = document.querySelectorAll('.proctor-type-cbox:checked').length;

    if(checked < 1) {
      this.setState({
        invalid: true
      }, function(){
        window.scrollTo(0, 0);
      });

      return false;
    }

    const data = {
      proctorTypes: this.state.proctorTypes
    }

    this.props.store.RegisterStore.updateProctor(data, this.props.nextStep);
  }

  render() {
    const { lock, translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;
    const { userSettings } = SettingsStore;

    if(!SessionStore.loading) {
      return(
        <form
          className="panel proctor-type-form"
          onSubmit={!lock ? (e) => this.props.checkValidity(e, this.handleSubmit) : this.props.nextStep}
          noValidate
        >
          <div className="panel__header">
            <h3 className="panel__title"><legend>{translation.heading}</legend></h3>
          </div>

          <fieldset className="panel__body">
            {/* <h4 className="form-heading">{translation.languages.heading}</h4>

            <ul className="switch-list">
              {
                Object
                  .keys(translation.languages.options)
                  .map(
                    (key) =>
                    <li key={key}>
                      <label htmlFor={`register-language-${key}`}>{translation.languages.options[key].label}</label>
                      <input type="checkbox" id={`register-language-${key}`} name="languages[]" className="switch-input" value={key} />
                      <label className="switch-label" htmlFor={`register-language-${key}`}><span className="meta">{translation.languages.options[key].label}</span></label>
                    </li>
                  )
              }
            </ul> */}

            {!lock &&
              <p className="note note--prominent">
                {translation.proctor_type.tooltip}
              </p>
            }

            {this.state.invalid &&
              <span className="note note--prominent note--error">
                {translation.proctor_type.none_selected}
              </span>
            }

            {SessionStore.proctorTypeList.map(
              (key, i) => {
                if(
                  (
                    userSettings.type === 'individual-proctor' &&
                    key.sid !== config.testingCenterSid
                  ) || (
                    userSettings.type !== 'individual-proctor' &&
                    key.sid === config.testingCenterSid
                  )
                ) {
                  return (
                    <div className="form-subgroup" key={i}>
                      <ul className="switch-list">
                        {key.subCategories.filter(function(obj){
                          return obj.allowSelfSelection;
                        }).map(
                          (subKey, j) => {
                            if(subKey.sid !== config.testingAdministratorSid) {
                              return (
                                <li key={j}>
                                  <label htmlFor={`register-type${i}-${j}`}>
                                    {subKey.title}
                                  </label>

                                  <input
                                    type="checkbox"
                                    id={`register-type${i}-${j}`}
                                    className="switch-input proctor-type-cbox"
                                    value={subKey.sid}
                                    onChange={(e) => this.handleToggle(e)}
                                    defaultChecked={this.state.proctorTypes.indexOf(subKey.sid) > -1}
                                    disabled={lock ? true : false}
                                  />

                                  <label
                                    className="switch-label"
                                    htmlFor={`register-type${i}-${j}`}
                                  >
                                    <span className="meta">{subKey.title}</span>
                                  </label>
                                </li>
                              )
                            }

                            return null;
                          }
                        )}
                      </ul>
                    </div>
                  )
                }

                return null;
              }
            )}

            {/* <ul className="switch-list">
              {
                Object
                  .keys(translation.proctor_type.options)
                  .map(
                    (key) =>
                    <li key={key}>
                      <label htmlFor={`register-type-${key}`}>{translation.proctor_type.options[key].label}</label>
                      <input type="checkbox" id={`register-type-${key}`} name="languages[]" className="switch-input" value={key} />
                      <label className="switch-label" htmlFor={`register-type-${key}`}><span className="meta">{translation.proctor_type.options[key].label}</span></label>
                    </li>
                  )
              }
            </ul> */}

            <div className="panel__actions actions">
              <button className="actions__btn actions__btn--secondary" onClick={this.props.prevStep} type="button">{translation.back}</button>
              <button className="actions__btn actions__btn--primary" type="submit">{translation.button}</button>
            </div>
          </fieldset>
        </form>
      )
    }

    return null;
  }
})

export default translate('ProctoringInfo')(ProctoringInfo);



// WEBPACK FOOTER //
// ./src/app/components/Register/ProctoringInfo.js